<template>
  <div class="px-4 py-3">
    <v-form ref="form" v-model="valid" lazy-validation>
      <validation-observer v-slot="{ handleSubmit }">
        <v-row no-gutters>
          <!-- Phần "THÔNG TIN KH" -->
          <v-col class="pr-2" cols="12">
            <v-card
              class="py-3 px-4 ma-0"
              outlined
              style="background: #FEFBFB"
              tile
            >
              <div class="d-flex align-center justify-space-between">
                <div style="color: rgba(88, 88, 88, 1); font-weight: 600; font-size: 16px;">
                  Xác nhận thông tin khách hàng
                </div>
                <div @click="clickValidate()">
                  <v-btn
                    min-width="70"
                    height="32"
                    class="mr-0"
                    color="#AC0606"
                    @click.prevent="handleSubmit(submitForm)"
                  >
                    Tiếp
                  </v-btn>
                </div>
              </div>
            </v-card>
          </v-col>
          <v-col class="pr-2" cols="4" v-if="dataForm.customers">
            <v-card
              class="py-3 px-4 ma-0"
              style="background: #fff;"
              outlined
              tile
            >
              <div class="align-center">
                <div style="color: rgba(88, 88, 88, 1); font-weight: 600; font-size: 14px;">
                  Thông tin khách hàng
                </div>
                <div style="color: #9D9D9D; font-weight: 600; font-size: 10px; font-style: italic;">
                  ( Thông tin của contact )
                </div>
              </div>
              <v-row>
                <v-col cols="1">
                  <v-icon color="#000">
                    mdi-account-circle
                  </v-icon>
                </v-col>
                <v-col cols="11">
                  <validation-provider
                    v-slot="{ errors }"
                    name="Tên khách hàng"
                    :rules="'required|max:100'"
                  >
                    <v-text-field
                      label="Tên khách hàng"
                      :error-messages="errors"
                      placeholder="Nhập tên khách hàng"
                      dense
                      @change="isEdited = true"
                      v-model.trim="dataForm.customers[0].fullName"
                    ></v-text-field>
                  </validation-provider>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="1">
                  <v-icon color="#000">
                    mdi-phone
                  </v-icon>
                </v-col>
                <v-col cols="11">
                  <validation-provider
                    v-slot="{ errors }"
                    name="Số điện thoại"
                    :rules="{ required: true, regex: /^(\d{10}|\d{11}|\d{12})$/ }"
                  >
                    <v-text-field
                      :error-messages="errors"
                      label="Số điện thoại"
                      placeholder="Nhập số điện thoại "
                      dense
                      @change="isEdited = true"
                      v-model.trim="dataForm.customers[0].mobile"
                    ></v-text-field>
                  </validation-provider>
                </v-col>
              </v-row>
            </v-card>
          </v-col>
          <v-col class="pr-2" cols="8">
            <v-card
              class="py-3 px-4 ma-0"
              style="background: #fff;"
              outlined
              tile
            >
              <div class="align-center">
                <div style="color: rgba(88, 88, 88, 1); font-weight: 600; font-size: 14px;">
                  Thông tin nhận hàng
                </div>
                <div style="color: #9D9D9D; font-weight: 600; font-size: 10px; font-style: italic;">
                  ( Thông tin của người nhận hàng có thể khác thông tin khách hàng )
                </div>
              </div>
              <v-row>
                <v-col cols="6" class="py-0">
                  <v-row>
                    <v-col cols="1">
                      <v-icon color="#000">
                        mdi-account-circle
                      </v-icon>
                    </v-col>
                    <v-col cols="11">
                      <validation-provider
                        v-slot="{ errors }"
                        name="Tên người nhận"
                        :rules="'required|max:100'"
                      >
                        <v-text-field
                          :error-messages="errors"
                          label="Tên người nhận"
                          placeholder="Nhập tên người nhận"
                          dense
                          @change="isEdited = true"
                          v-model.trim="receiverName"
                        ></v-text-field>
                      </validation-provider>
                    </v-col>
                  </v-row>
                </v-col>

                <v-col cols="6" class="py-0">
                  <v-row>
                    <v-col cols="1">
                      <v-icon color="#000">
                        mdi-account-circle
                      </v-icon>
                    </v-col>
                    <v-col cols="11">
                      <validation-provider
                        v-slot="{ errors }"
                        name="Số điện thoại người nhận"
                        :rules="{ required: true, regex: /^(\d{10}|\d{11}|\d{12})$/ }"
                      >
                        <v-text-field
                          label="Số điện thoại"
                          :error-messages="errors"
                          placeholder="Nhập số điện thoại"
                          dense
                          @change="isEdited = true"
                          v-model.trim="phone"
                        ></v-text-field>
                      </validation-provider>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>

              <v-row>
                <v-col cols="6" class="py-0">
                  <v-row>
                    <v-col cols="1" class="py-0">
                      <v-icon color="#000">
                        mdi-map-marker
                      </v-icon>
                    </v-col>
                    <v-col cols="11" class="py-0">
                      <v-row>
                        <v-col>
                          <validation-provider
                            v-slot="{ errors }"
                            name="Tỉnh / T.P"
                            :rules="'required'"
                          >
                            <v-autocomplete
                              :error-messages="errors"
                              :items="listProvince"
                              item-value="id"
                              item-text="ten"
                              :aLight="'right'"
                              placeholder="Lựa chọn"
                              label="Tỉnh / T.P"
                              attach
                              dense
                              v-model="provinceId"
                              @change="isEdited = true;getDistricts()"
                              :menu-props="{ top: true, offsetY: true, maxHeight: '150' }"
                            ></v-autocomplete>
                          </validation-provider>
                        </v-col>
                        <v-col>
                          <validation-provider
                            v-slot="{ errors }"
                            name="Quận/Huyện"
                            :rules="'required'"
                          >
                          <v-autocomplete
                            :error-messages="errors"
                            :items="listDistrict"
                            item-value="id"
                            item-text="ten"
                            :aLight="'right'"
                            placeholder="Lựa chọn"
                            label="Quận/Huyện"
                            attach
                            dense
                            @change="isEdited = true;getWards()"
                            v-model="districtId"
                            :menu-props="{ top: true, offsetY: true, maxHeight: '150' }"
                          ></v-autocomplete>
                          </validation-provider>
                        </v-col>
                      </v-row>
                    </v-col>
                  </v-row>
                </v-col>
                <v-col cols="6" class="py-0">
                  <v-row>
                    <v-col>
                      <validation-provider
                        v-slot="{ errors }"
                        name="Phường/Xã"
                        :rules="'required'"
                      >
                        <v-autocomplete
                          :error-messages="errors"
                          :items="listWard"
                          item-value="id"
                          item-text="ten"
                          :aLight="'right'"
                          placeholder="Lựa chọn"
                          label="Phường/Xã"
                          attach
                          dense
                          v-model="wardId"
                          @change="isEdited = true"
                          :menu-props="{ top: true, offsetY: true, maxHeight: '150' }"
                        ></v-autocomplete>
                      </validation-provider>
                    </v-col>
                    <v-col>
                      <validation-provider
                        v-slot="{ errors }"
                        name="Địa chỉ chi tiết"
                        :rules="'required|max:255'"
                      >
                        <v-text-field
                          :error-messages="errors"
                          label="Địa chỉ chi tiết ( số nhà, đường, thôn,...)"
                          placeholder="Nhập địa chỉ chi tiết"
                          dense
                          @change="isEdited = true"
                          v-model.trim="detailAddress"
                        ></v-text-field>
                      </validation-provider>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
            </v-card>
          </v-col>
        </v-row>

        <v-row>
          <!-- Phần "THÔNG TIN CON" -->
          <v-col class="pr-2" cols="12">
            <v-card
              class="py-3 px-4 ma-0"
              style="background: #fff;"
              outlined
              tile
            >
              <div class="align-center d-flex justify-space-between">
                <div style="color: rgba(88, 88, 88, 1); font-weight: 600; font-size: 16px;">
                  Thông tin con & tài khoản
                </div>
                <div style="color: blue; font-size: 14px; cursor: pointer; font-style: italic; text-decoration: underline;" @click="addChild">
                  + Thêm con
                </div>
              </div>
              <v-row>
                <v-col class="group-child">
                  <div :style="{ width: `${childCustomers.length * 515}px` }">
                    <div v-for="(item, index) in childCustomers" :key="index" class="pt-10 box-child">
                      <div class="item-child pr-8" :class="item.coreUser && item.coreUser.isMainAcount ? 'main-child' : ''">
                        <span class="child-card px-4">Con {{ index + 1 }}</span>
                        <v-row>
                          <v-col cols="11" offset="1">
                            <validation-provider
                              v-slot="{ errors }"
                              name="Tên con"
                              :rules="'required|max:100'"
                            >
                              <v-text-field
                                :error-messages="errors"
                                label="Tên con"
                                placeholder="Nhập tên con"
                                dense
                                @change="isEdited = true"
                                v-model.trim="item.fullName"
                              ></v-text-field>
                            </validation-provider>
                          </v-col>
                        </v-row>
                        <v-row>
                          <v-col cols="11" offset="1">
                            <div class="d-flex align-center justify-space-between" style="font-size: 12px;">
                              <div>Năm sinh</div>
                              <div style="color: #B1B1B0; font-style: italic;">( Độ tuổi: <span>{{ item.birthdayDescription || '--' }}</span> )</div>
                            </div>
                            <validation-provider
                              v-slot="{ errors }"
                              name="Năm sinh"
                              :rules="'required'"
                            >
                              <v-select
                                :items="selectYears"
                                :error-messages="errors"
                                :aLight="'right'"
                                placeholder="Chọn năm sinh"
                                label=""
                                attach
                                dense
                                @change="isEdited = true"
                                v-model="item.birthday"
                                :menu-props="{ bottom: true, offsetY: true, maxHeight: '150' }"
                              ></v-select>
                            </validation-provider>
                          </v-col>
                        </v-row>
                        <v-row>
                          <v-col cols="11" offset="1">
                            <div class="d-flex align-center justify-space-between" style="font-size: 12px;">
                              <div>Tài khoản vui học</div>
                              <div style="color: #B1B1B0; font-style: italic;">( UID : {{ item.coreUser && item.coreUser.coreUserId ? item.coreUser.coreUserId : '--' }} )</div>
                            </div>
                            <div class="d-flex" v-if="item.coreUser">
                              <div class="pt-2" v-if="item.coreUser.isMainAcount">
                                <span class="px-2" style="border-bottom: 1px solid #d2d2d2; display: inline-block; height: 21px; font-size: 12px; font-style: italic; font-weight: bold;">Tài khoản chính - </span>
                              </div>
                              <v-text-field
                                label=""
                                placeholder="Chưa có tài khoàn vui học"
                                dense
                                disabled
                                @change="isEdited = true"
                                v-model="item.coreUser.userName"
                              ></v-text-field>
                            </div>
                            <div class="d-flex" v-if="!item.coreUser">
                              <v-text-field
                                label=""
                                placeholder="Chưa có tài khoàn vui học"
                                dense
                                disabled
                              ></v-text-field>
                            </div>
                          </v-col>
                        </v-row>
                        <v-row>
                          <v-col cols="11" offset="1">
                            <div class="d-flex align-center justify-space-between" style="font-size: 12px;">
                              <div>Trạng thái mua</div>
                            </div>
                            <div class="time-line1" v-if="!getHistoryOfChild(item.id) || !getHistoryOfChild(item.id).orders.length">
                              <ol class="pt-3">
                                <li class="pt-3">
                                  <span class="tl-date">Chưa có đơn</span>
                                </li>
                              </ol>
                            </div>
                            <div class="time-line" v-if="getHistoryOfChild(item.id) && getHistoryOfChild(item.id).orders.length">
                              <ol class="pt-3">
                                <li class="pt-3" v-for="(log, indexL) in getHistoryOfChild(item.id).orders" :key="index + 'l' + indexL">
                                  <span class="tl-date">{{ formatDateDMY(log.createdAt) }}</span>
                                  <br>
                                  <span class="tl-detail" v-for="(prd, indexP) in log.orderProduct" :key="index + 'l' + indexL + 'p' + indexP" style="display: block;">
                                    <span v-if="prd.orderType == 1">(Mua mới) </span>
                                    <span v-if="prd.orderType == 2">(Gia hạn) </span>
                                    {{ prd.productName }}
                                  </span>
                                </li>
                              </ol>
                            </div>
                          </v-col>
                        </v-row>
                        <v-row class="align-self-end">
                          <v-col>
                            <div class="d-flex align-center justify-end">
                              <div v-if="!item.coreUser || !item.coreUser.userName" style="color: blue; font-size: 14px; cursor: pointer; font-style: italic;" @click="deleteChild(item.customerId, item.tempId)">Xóa con</div>
                            </div>
                          </v-col>
                        </v-row>
                      </div>
                    </div>
                  </div>
                </v-col>
              </v-row>

            </v-card>
          </v-col>
        </v-row>
      </validation-observer>
    </v-form>
  </div>
</template>

<script>
import TokenService from '../../../helpers/token';
// import OrderRepository from "@/pages/order-management/services/OrderRepository.js";\
import RepositoryFactory from '@/repositories/RepositoryFactory';
const AddressRepository = RepositoryFactory.get('address');
const ContactRepository = RepositoryFactory.get('contact');
import { regex } from '../../../helpers/constants'

export default {
  name: "create-order-new",

  data() {
    return {
      valid: false,
      childs: [{}],
      listProvince: [],
      listWard: [],
      listDistrict: [],
      provinceId: null,
      districtId: null,
      wardId: null,
      contactId: null,
      detailAddress: null,
      receiverName: null,
      phone: null,
      mainCustomer: null,
      dataForm: {
        customers: [{}]
      },
      selectYears: [],
      contactHistories: [],
      isEdited: false,
      regex,
      receiverId: null,
    };
  },

  computed: {
    childCustomers() {
      return (
        this.dataForm.customers.filter(
          customer =>
            customer.position === 'child' &&
            !_.get(customer, 'isDeleted', false)
        ) || [{}]
      );
    },
  },

  async created() {
    this.contactId = parseInt(this.$route.params.id);
    this.getProvinces();
    await this.getContactAddress();
    this.getContactInfo();
    let selectYears = []
    const yearNow = new Date().getFullYear();
    for (let i = yearNow; i >= 1900; i--) {
      selectYears.push(i);
    }
    this.selectYears = selectYears;
    console.log('log', this.$route.query.url_back);
  },

  methods: {
    async getContactAddress() {
      const params = {
        contactId: this.contactId,
        page: 0,
        limit: 1,
      };
      const res = await ContactRepository.getContactAddress(params);
      if (res.data && res.data.length) {
        this.receiverId = res.data[0].id;
        this.provinceId = res.data[0].provinceId;
        if (res.data[0].provinceId) {
          this.getDistricts();
        }
        this.districtId = res.data[0].districtId;
        if (res.data[0].provinceId && res.data[0].districtId) {
          this.getWards();
        }
        this.wardId = res.data[0].wardId;
        this.detailAddress = res.data[0].detailAddress;
        this.receiverName = res.data[0].receiverName;
        this.phone = res.data[0].phone;
      }
    },
    async getContactInfo() {
      const respond = await ContactRepository.detail(this.$route.params.id);
      if (_.get(respond, 'success', false) && _.get(respond, 'data', null)) {
        const res = await ContactRepository.getContactInfo(this.contactId);

        const dataContact = _.get(respond, 'data', {});
        const contactSourceIds = _.get(dataContact, 'contactSources', []).map(
          contactSource => contactSource.id
        );

        const customers = res.data.customers.map(customer => {
          const customerTemp = customer;
          customerTemp.customerId = customerTemp.id;
          customerTemp.phones = _.get(customer, 'phones', []).map(
            data => data.phoneNumber
          );
          customerTemp.isNew = false;

          if (!_.get(customer, 'isMainCustomer', false)) {
            if (!Array.isArray(customerTemp.phones)) {
              customerTemp.phones = [];
            }
            customerTemp.mobile = _.get(customerTemp, 'phones[0]', '');
            customerTemp.phones.shift();
          }

          if (customer.isMainCustomer && customer.fullName === '') {
            customerTemp.fullName = customerTemp.mobile;
          }
          if (customer.isMainCustomer) {
            if (!this.receiverName) {
              this.receiverName = customerTemp.fullName
            }
            if (!this.phone) {
              this.phone = customerTemp.mobile
            }
            if (!this.receiverId) {
              if (customer.province && customer.province.id) {
                this.provinceId = customer.province.id;
                this.getDistricts();
              }
              if (customer.district && customer.district.id) {
                this.districtId = customer.district.id;
                this.getWards();
              }
              if (customer.ward && customer.ward.id) {
                this.wardId = customer.ward.id;
              }
              if (customer.detailAddress) {
                this.detailAddress = customer.detailAddress;
              }
            }
          }

          return customerTemp;
        });

        const mainCustomer = customers.find(
          customer => customer.isMainCustomer
        ) || {
          mobile: '',
          isMainCustomer: true,
          position: 'other',
          phones: [],
          courseRegister: []
        };

        const customersTemp = [
          mainCustomer,
          ...customers.filter(customer => !customer.isMainCustomer)
        ];

        let customerChildFirst = customersTemp.find(c => c.position === 'child');
        if (!customerChildFirst) {
          customersTemp.push( {
            customerId: new Date().getTime(),
            isMainCustomer: false,
            position: 'child',
            fullName: '',
            birthday: 0,
            courseRegister: [],
            isDataTemp: true,
          });
        }
        this.dataForm = {
          ...dataContact,
          contactSourceIds,
          customers: customersTemp,
          productGroups: dataContact.groups.map(dataGroup => dataGroup.id),
        };
        this.getContactHistories();
        // if(this.stepOrder === 1) {
        //     this.getListCustomerOrder(this.dataForm.customers)
        // }
        // this.dataFormOld = JSON.stringify(this.dataForm);
        // if(customersTemp.length > 0) {
        //   this.schoolId = customersTemp[0].schoolIds && customersTemp[0].schoolIds.length === 1 ? customersTemp[0].schoolIds[0] : ''
        // }
      }
    },
    addChild() {
      if (this.childCustomers.length >= 7) {
        this.$swal({
          type: 'error',
          title: 'Lỗi !',
          text: 'Giới hạn tối đa: 7 con ',
        });
        return;
      }
      this.isEdited = true;
      this.dataForm.customers.push({
        customerId: null,
        isMainCustomer: false,
        isDeleted: false,
        position: 'child',
        fullName: null,
        birthday: null,
        courseRegister: [],
        isDataTemp: true,
        tempId: Math.random(),
      });
    },
    clickValidate() {
      if(this.phone && this.provinceId && this.districtId && this.wardId && this.contactId && this.detailAddress && this.receiverName) {
        const noBrithday = this.childCustomers.find(customer => !customer.birthday);
        if(noBrithday) {
          return this.$swal({
            type: 'error',
            title: 'Lỗi !',
            text: 'Năm sinh của con không được để trống',
          });
        }
      }
    },
    submitForm() {
      if (!this.isEdited) {
        this.goToCreateOrder();
      }
      if (this.isEdited) {
        this.$swal({
          title: 'Thông báo',
          text: 'Các thông tin sẽ được cập nhật vào hệ thống thay thế cho các thông tin cũ?',
          type: 'warning',
          showCancelButton: true,
          confirmButtonText: 'Đồng ý',
          cancelButtonText: 'Hủy bỏ'
        }).then(async result => {
          if (result.value) {
            this.goToCreateOrder();
          }
        });
      }
    },
    async goToCreateOrder() {
      const dataReceiver = {
        contactId: this.contactId,
        receiverName: _.trim(this.receiverName),
        phone: _.trim(this.phone),
        provinceId: this.provinceId,
        districtId: this.districtId,
        wardId: this.wardId,
        detailAddress: _.trim(this.detailAddress),
      };
      let resR;
      if (!this.receiverId) {
        resR = await ContactRepository.createContactAddressReceiver(dataReceiver);
      }
      if (this.receiverId) {
        resR = await ContactRepository.updateContactAddressReceiver(this.receiverId, dataReceiver);
      }
      if (resR && resR.data) {
        const dataUser = TokenService.getUser() || {};
        const dataUpdate = {
          productGroups: _.get(this.dataForm, 'productGroups', []),
          statusId: _.get(this.dataForm, 'statusId', null),
          userId: _.get(this.dataForm, 'userId', null) || +_.get(dataUser, 'id', 0),
          userMarketingName: _.trim(this.dataForm.userMarketingName),
          contactSourceIds: _.get(this.dataForm, 'contactSourceIds', []),
          description: _.trim(this.dataForm.description),
          customers: [],
          schoolLevelId: _.get(this.dataForm, 'schoolLevelId', null),
          typeId: _.get(this.dataForm, 'typeId', null)
        };

        let checkErrorPhone = false;
        dataUpdate.customers = this.dataForm.customers.map(customer => {
          const customerTemp = { ...customer };
          const customerTempMobile = customerTemp.mobile;
          let customerId = _.get(customer, 'isNew', true)
            ? null
            : (customerId = _.get(customer, 'customerId', null));
          if (
            !_.get(customer, 'isMainCustomer', false) &&
            customerTemp.mobile &&
            customerTemp.mobile !== ''
          ) {
            if (!Array.isArray(customerTemp.phones)) {
              customerTemp.phones = [];
            }
            customerTemp.phones.unshift(customerTemp.mobile);
            customerTemp.mobile = '';
          }

          if (customerTemp.phoneSub) {
            if (customerTemp.phoneSub === customerTempMobile) {
              checkErrorPhone = true;
            }
            customerTemp.phones.push(customerTemp.phoneSub);
          }
          if(customerTemp.isMainCustomer && customerTempMobile && customerTemp.phones.includes(customerTempMobile)) {
            checkErrorPhone = true;
          }

          if (customerTemp.birthday < 1900) {
            customerTemp.birthday = null;
          }

          if (!customerTemp.positionTitle) {
            customerTemp.positionTitle = 'Khác';
          }

          if (
            _.get(customerTemp, 'isMainCustomer', false) &&
            !_.get(customerTemp, 'fullName', '')
          ) {
            customerTemp.fullName = _.get(customerTemp, 'mobile', '');
          }

          return {
            customerId,
            isDeleted: _.get(customerTemp, 'isDeleted', false),
            mobile: _.get(customerTemp, 'mobile', ''),
            isMainCustomer: _.get(customerTemp, 'isMainCustomer', false),
            fullName: _.trim(customerTemp.fullName),
            birthday: _.get(customerTemp, 'birthday', null),
            birthdayDescription: _.trim(customer.birthdayDescription),
            email: _.get(customerTemp, 'email', ''),
            capability: _.trim(customerTemp.capability),
            position: _.get(customerTemp, 'position', 'other'),
            positionTitle: _.trim(customerTemp.positionTitle) || 'Khác',
            tinhId: _.get(customerTemp, 'tinhId', 0) || 0,
            huyenId: _.get(customerTemp, 'huyenId', 0) || 0,
            xaId: _.get(customerTemp, 'xaId', 0) || 0,
            detailAddress: _.trim(customerTemp.detailAddress),
            description: _.trim(customerTemp.description),
            phones: _.get(customerTemp, 'phones', []),
            productDescription: _.trim(customer.productDescription),
          };
        });

        if (checkErrorPhone) {
          return this.$swal({
            type: 'error',
            title: 'Lỗi !',
            text: 'Số điện thoại phụ không được giống số điện thoại chính',
          });
        }
        if(!dataUpdate.typeId) {
          return this.$swal({
            type: 'error',
            title: 'Lỗi !',
            text: 'Contact chưa thuộc loại hình nào!'
          });
        }
        this.loading = this.$loading.show();
        const response = await ContactRepository.update(
          dataUpdate,
          this.$route.params.id
        );

        if (response.errors) {
          this.loading.hide();
          this.$swal({
            title: response.message ? response.message : (Array.isArray(response.errors) ? response.errors[0].message : response.errors.message),
            confirmButtonText: 'Xem contact chính',
            showCancelButton: true,
            cancelButtonText: 'Quay lại'
            }).then((res) => {
            if (res.value) {
                let routeData = this.$router.resolve({
                name: 'ContactDetail',
                params: {
                    id: this.dataForm.mainId || 0
                }
                })
                window.open(routeData.href, '_blank')
            }
        })
        } else if (_.get(response, 'data.isExist', false)) {
          this.loading.hide();
          this.$swal({
            title: 'Cập nhật contact không thành công, Số điện thoại đã tồn tại!',
            type: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Xem contact',
            closeOnConfirm: false,
            cancelButtonText: 'Huỷ Bỏ'
          }).then(result => {
            if (result.value) {
              return this.$router.push({
                name: 'ContactDetail',
                params: {
                  id: _.get(response, 'data.contactId', null)
                }
              });
            }
          });
        } else {
          this.loading.hide();
          const query=  {
            record_type: this.$route.query.record_type,
            record_id: this.$route.query.record_id,
            url_back: this.$route.query.url_back,
          }
          if(this.$route.query.url_back) {
            query.isDuo= this.$route.query.isDuo
          }
          if(this.$route.query.idTransfer) {
            query.idTransfer= this.$route.query.idTransfer
          }
          this.$router.push({
            name: 'CreateOrderNew',
            params: {
              id: this.contactId,
            },
            query: {
             ...query
            },
          });
        }
      }
    },
    // Lấy danh sách Tỉnh/Thành Phố
    async getProvinces() {
      const respond = await AddressRepository.provinces({ limit: 100 });
      if (_.get(respond, 'success', false)) {
        this.listProvince = _.get(respond, 'data', []).filter(
          data => data.id != 0
        );
      } else {
        this.$swal({
          type: 'error',
          title: 'Lỗi !',
          text: _.get(respond, 'message', '')
        });
      }
    },

    // Lấy danh sách Quận/Huyện
    async getDistricts() {
      const loader = this.$loading.show();
      this.districtId = null;
      this.wardId = null;
      this.listWard = [];
      const respond = await AddressRepository.districts(
        { limit: 100 },
        this.provinceId,
      );
      loader.hide();
      if (_.get(respond, 'success', false)) {
        this.listDistrict = _.get(respond, 'data', []);
      } else {
        this.$swal({
          type: 'error',
          title: 'Lỗi !',
          text: _.get(respond, 'message', '')
        });
      }
    },

    async getWards() {
      const loader = this.$loading.show();
      this.wardId = null;
      const respond = await AddressRepository.wards(
        { limit: 100 },
        this.provinceId,
        this.districtId
      );
      loader.hide();
      if (_.get(respond, 'success', false)) {
        this.listWard = _.get(respond, 'data', []);

      } else {
        this.$swal({
          type: 'error',
          title: 'Lỗi !',
          text: _.get(respond, 'message', '')
        });
      }
    },

    async getContactHistories() {
      const customerIds = this.dataForm.customers.map(item => item.id);
      const respond = await ContactRepository.getContactHistories({ customerIds });
      if (_.get(respond, 'success', false)) {
        this.contactHistories = respond.data;
      } else {
        this.$swal({
          type: 'error',
          title: 'Lỗi !',
          text: _.get(respond, 'message', '')
        });
      }
    },
    getHistoryOfChild(id) {
      return this.contactHistories.find(item => item.customerId === id);
    },
    async deleteChild(customerId, tempId = null){
      if (!customerId) {
        const index = this.dataForm.customers.findIndex(
          customer => customer.tempId === tempId
        );
        this.dataForm.customers.splice(index, 1);
        this.isEdited = true;
        return;
      }
      let res = await ContactRepository.checkCanDeleteCustomer(customerId);
      if(res.data.canRemove){
        this.onClickRemoveCustomer(customerId)
      } else {
        this.$swal({
          text: res.data.message,
          type: 'warning',
          title: 'Thông báo !',
          icon: 'warning',
        })
      }
    },
    onClickRemoveCustomer(customerId) {
      this.$swal({
        title: 'Xóa thông tin của Con',
        text: 'Bạn có thực sự muốn xoá ?',
        type: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Đồng ý',
        cancelButtonText: 'Hủy bỏ'
      }).then(async result => {
        if (result.value) {
          const index = this.dataForm.customers.findIndex(
            customer => customer.customerId === customerId
          );
          if (index === -1) {
            return;
          }
          this.isEdited = true;
          const customerTemp = this.dataForm.customers[index];
          customerTemp.isDeleted = true;
          customerTemp.courseRegister = [];
          this.dataForm.customers.splice(index, 1);
          if (this.$route.params.id && !_.get(customerTemp, 'isNew', true)) {
            this.dataForm.customers.push(customerTemp);
          }
        }
      });
    }
  },
};
</script>

<style lang="scss" scoped>
::v-deep.v-input__control {
  min-height: 10px;
}

::v-deep .v-data-table th {
  font-size: 16px !important;
}
::v-deep .v-data-table td,
::v-deep .v-data-table table thead tr th {
  font-size: 14px !important;
  padding: 15px 12px !important;
}

.v-label {
  font-size: 10px;
}
.info-payment-price {
  height: 38px;
  background: #d9d9d9;
  border: 1px solid #00000033;
  border-radius: 3px;
  width: 100%;
  text-align: right;
  padding: 5px 4px;
}
::v-deep .note .v-input__slot {
  background: #fff !important;
}
.price {
  background: #d9d9d9;
  border: 1px solid rgba(0, 0, 0, 0.4);
  padding: 5px;
  font-weight: 400;
  height: 38px;
  line-height: 28px;
  border-radius: 4px;
}
::v-deep
  .v-text-field--outlined.v-input--dense.v-text-field--outlined
  > .v-input__control
  > .v-input__slot {
  min-height: 38px !important;
}

.time-line1 {
  height: 200px;
  overflow-y: auto;
  ol {
    list-style-type: none;
  }

  .tl-date {
    color: #717171;
  }
  .tl-detail {
    color: #20201F;
    font-style: italic;
  }

  li {
    position: relative;
    margin: 0;
    padding-bottom: 1em;
    padding-left: 5px;
  }

  li:after {
    content: '';
    background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' aria-hidden='true' viewBox='0 0 32 32' focusable='false'%3E%3Ccircle stroke='none' fill='%23FF9D73' cx='16' cy='16' r='10'%3E%3C/circle%3E%3C/svg%3E");
    position: absolute;
    left: -20px;
    height: 15px;
    width: 15px;
    top: 15px;
  }
}

.time-line {
  max-height: 200px;
  overflow-y: auto;
  ol {
    list-style-type: none;
  }

  .tl-date {
    color: #717171;
  }
  .tl-detail {
    color: #20201F;
    font-style: italic;
  }

  li {
    position: relative;
    margin: 0;
    padding-bottom: 1em;
    padding-left: 5px;
  }

  li:before {
    content: '';
    background-color: #FF9D73;
    position: absolute;
    bottom: 0;
    top: 0;
    left: -14px;
    width: 3px;
  }

  li:after {
    content: '';
    background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' aria-hidden='true' viewBox='0 0 32 32' focusable='false'%3E%3Ccircle stroke='none' fill='%23FF9D73' cx='16' cy='16' r='10'%3E%3C/circle%3E%3C/svg%3E");
    position: absolute;
    left: -20px;
    height: 15px;
    width: 15px;
    top: 15px;
  }
}

.group-child {
  overflow-x: auto;
}

.box-child {
  width: 500px;
  float: left;
  margin-right: 15px;
}
.item-child {
  border: 1px solid #FFE9E9;
  border-radius: 0px 10px 10px 10px;
  min-height: 550px;
  // position: relative;

  .child-card {
    position: relative;
    top: -21px;
    left: -1px;
    color: #626262;
    display: inline-block;
    background: #FFE9E9;
    border-radius: 8px 8px 0px 0px;
  }
}

.main-child {
  border: 1px solid #D37531;
  .child-card {
    color: #fff;
    display: inline-block;
    background: #D37531;
  }
}
</style>
